import React from 'react';

import { Provider } from 'react-redux';

import ConnectedDefaultReminders from './default_reminders';
import configureStore from './store/configure';

export default function CompanyReminders({ ...props }) {
  const store = configureStore(props);

  return (
    <Provider store={store}>
      <ConnectedDefaultReminders />
    </Provider>
  );
}
